import { useEffect, useCallback, useMemo } from "react";
import { Dialog, Button } from "@blofin/blofin-ui";
import { useTranslations } from "use-intl";
import { useStoreState } from "../store/useStore";
import { SwitchParams } from "../OverviewPopper/type";

const SUB_ACCOUNT_CHANGE_KEY = "sub-account-change";

interface SubAccountChangeData {
  timestamp: number;
  params: SwitchParams;
}

const useSubAccountListen = () => {
  const { theme, showTheme } = useStoreState();

  const realTheme = useMemo(() => {
    return showTheme ? theme : "light";
  }, [theme, showTheme]);

  const t = useTranslations("account");
  const h = useTranslations("header");

  const handleStorageChange = useCallback(
    (event: StorageEvent) => {
      if (event.key !== SUB_ACCOUNT_CHANGE_KEY || !event.newValue) {
        return;
      }

      // 如果当前窗口有焦点，不显示弹窗
      if (document.hasFocus()) {
        return;
      }

      try {
        const data: SubAccountChangeData = JSON.parse(event.newValue);
        sessionStorage.removeItem("global-role");
        Dialog.show({
          title: h("swichAccount"),
          content: (
            <div className={realTheme === "light" ? "text-light-label" : "text-dark-label"}>
              {t("switchRefeshTip", { accountName: data.params.toName })}
            </div>
          ),
          size: "small",
          hideIcon: true,
          theme: realTheme || "light",
          footer: (
            <div className="flex justify-center items-center w-full">
              <Button
                variant="primary"
                size="medium"
                className="w-full"
                onClick={() => {
                  if (window) {
                    window.location.reload();
                  }
                }}
              >
                {t("refresh")}
              </Button>
            </div>
          )
        });
      } catch (error) {
        console.error("Failed to parse sub account change data:", error);
      }
    },
    [realTheme, h, t]
  );

  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [handleStorageChange]);

  const triggerSubAccountChange = useCallback((params: SwitchParams) => {
    const changeData: SubAccountChangeData = {
      //localstorage当数据未发生改变时不触发
      timestamp: Date.now(),
      params
    };
    localStorage.setItem(SUB_ACCOUNT_CHANGE_KEY, JSON.stringify(changeData));
  }, []);

  return { triggerSubAccountChange };
};

export default useSubAccountListen;
